export default {
    iatTask: state => state.iatTask
}
